;(function (angular, _) {
  'use strict'

  class LegalFieldsController {

    get model () {
      return this.ngModel.$viewValue
    }

    set model (value) {
      this.ngModel.$setViewValue = value
    }
  }

  angular.module('kilo.common.components')
    .component('legalFields', {
      require: {
        ngModel: 'ngModel'
      },
      bindings: {
        allowAdmin: '<',
        disabled: '<'
      },
      controller: LegalFieldsController,
      templateUrl: '/app/common/components/legal-fields/legal-fields.template.html'
    })
})(window.angular, window._)
